import { Navigate, Route, Routes } from 'react-router-dom';
import CreateBundlePage from './edit/CreateBundlePage';
import EditBundlePage from './edit/EditBundlePage';
import BundleListPage from './list/BundleListPage';

export default function BundlesRouter() {
  return (
    <Routes>
      <Route element={<BundleListPage />} index />
      <Route element={<CreateBundlePage />} path="create/*" />
      <Route element={<EditBundlePage />} path=":bundleId/*" />
      <Route element={<Navigate to="" />} path="*" />
    </Routes>
  );
}
